import React, { Suspense, lazy } from 'react';
import MainLoader from '~components/main-loader';

const ThemeReportsItemPage = lazy(() => import('./index.js'));

function ThemeReportsItemPageLazy(props) {
    return (
        <Suspense fallback={<MainLoader />}>
            <ThemeReportsItemPage {...props} />
        </Suspense>
    );
}

export default ThemeReportsItemPageLazy;
export { ThemeReportsItemPageLazy };

export const passportData = {
    title: 'Проект «Чистый воздух»',
    goal: 'Не допустить ситуацию, при которой компания должна заплатить штраф от оборота или получить ограничения на выплату дивидендов из-за нарушения правил выбросов загрязняющих веществ',
    status: '1) Эксперимент по квотированию продлен до 31.12.2026 г. 2) Подача заявления на КЭР продлена до 31.12.2024 г. 3) Сроки внедрения САК продлены на 2 года (внедрять теперь можно в течение 6 лет), для тех, кто получил КЭР',
    events: '1) Синхронизировать требования законодательства в области САК с целью создания непротиворечивых и рациональных требований по оснащению источников 2) Внести изменения в Правила квотирования выбросов загрязняющих веществ в атмосферный воздух с целью возможности изменения инвестиционной, производственной, ремонтной программ предприятия/квотируемого объекта в период реализации эксперимента, при условии снижения совокупного объема выбросов ПЗВ не менее чем на 20%',
};

export const documentsData2 = [
    {
        isImportant: true,
        themes: ['Единая система идентификации и аутентификации', 'Аудиторская деятельность'],
        title: 'Постановление Правительства РФ от 05.04.2022 № 593 «Об особенностях обращения лекарственных средств для медицинского применения при возникновении дефектуры или риска возникновения дефектуры в связи с введением в отношении РФ ограничительных мер экономического характера»',
        summary:
            'Устанавливаются требования к региональным и муниципальным программам в области энергосбережения и повышения энергетической эффективности (в том числе в сфере теплоснабжения)',
        date: 'DD month YYYY г. HH:MM',
        notifications: 10,
        messages: 10,
        type: 'Ключевой',
        isNew: true,
        hasChanges: false,
        isPlan: true,
        isGovernment: true,
    },
    {
        isImportant: true,
        themes: ['Постановления', 'Аудиторская деятельность'],
        title: 'Распоряжение Правительства РФ от 17.02.2022 № 283-р',
        summary: '',
        date: 'DD month YYYY г. HH:MM',
        notifications: 10,
        messages: 10,
        type: 'Ключевой',
        isNew: false,
        hasChanges: true,
        isPlan: true,
        isGovernment: true,
    },
    {
        isImportant: false,
        themes: ['Постановления', 'Аудиторская деятельность', 'Гражданский процессуальный кодекс'],
        title: 'Постановление Правительства РФ от 05.04.2022 № 593 «Об особенностях обращения лекарственных средств для медицинского применения при возникновении дефектуры или риска возникновения дефектуры в связи с введением в отношении РФ ограничительных мер экономического характера»',
        summary:
            'Устанавливаются требования к региональным и муниципальным программам в области энергосбережения и повышения энергетической эффективности (в том числе в сфере теплоснабжения)',
        date: 'DD month YYYY г. HH:MM',
        notifications: 10,
        messages: 10,
        type: 'Связанный',
        isNew: true,
        hasChanges: false,
        isPlan: true,
        isGovernment: true,
    },
    {
        isImportant: false,
        themes: ['Постановления', 'Аудиторская деятельность'],
        title: 'Распоряжение Правительства РФ от 17.02.2022 № 283-р',
        summary: '',
        date: 'DD month YYYY г. HH:MM',
        notifications: 10,
        messages: 10,
        type: 'Ключевой',
        isNew: false,
        hasChanges: true,
        isPlan: true,
        isGovernment: true,
    },
];

export const timelineData2 = [
    {
        title: 'Правительству РФ поручено обеспечить: «кардинальное снижение уровня загрязнения атмосферного воздуха в крупных промышленных центрах, в том числе уменьшение не менее чем на 20 процентов совокупного объема выбросов загрязняющих веществ в атмосферный воздух в наиболее загрязненных городах»',
        summary:
            'Указ Президента Российской Федерации от 07.05.2018 No 204 "О национальных целях и стратегических задачах развития Российской Федерации на период до 2024 года"',
        date: '07.05.2018',
        type: 'default',
    },
    {
        title: 'Утвержден порядок выдачи комплексных экологических разрешений, их продления, переоформления, пересмотра, внесения в них изменений, а также отзыва таких разрешений',
        summary:
            'Постановление Правительства Российской Федерации от 13.02.2019 No 143 "О порядке выдачи комплексных экологических разрешений, их переоформления, пересмотра, внесения в них изменений, а также отзыва"',
        date: '19.02.2019',
        type: 'default',
    },
    {
        title: 'Зафиксирован критерий 2) определения квот выбросов как: «уменьшение не менее чем на 20 % совокупного объема выбросов приоритетных загрязняющих веществ от квотируемых объектов (предприятий)»',
        summary: 'Доклад Виктории Абрамченко по вопросам снижения загрязнения воздуха',
        date: 'dd month year',
        type: 'filled',
    },
    {
        title:
            'Внесены изменения в Правила квотирования выбросов загрязняющих веществ в атмосферный воздух:\n' +
            '1. Межведомственный совет по проведению эксперимента по квотированию выбросов загрязняющих веществ наделен полномочиями вносить изменения в утвержденный план мероприятий по достижению квот выбросов в ряде ситуаций 2. Росприроднадзору рекомендуется устанавливать квоту в целом на квотируемый объект совокупно, по сумме всех ПЗВ (тонн/год), без привязки к конкретному источнику выбросов\n' +
            '3. Предусмотрена возможность изменения инвестиционной, производственной, ремонтной программ предприятия/квотируемого объекта в период реализации эксперимента, при условии снижения совокупного объема выбросов ПЗВ не менее чем на 20%',
        summary:
            'Приказ Минприроды "О внесении изменений в правила квотирования выбросов загрязняющих веществ (за исключением радиоактивных веществ) в атмосферный воздух"',
        date: '1-й квартал 2023 года',
        type: 'future',
    },
];

export const documentsData3 = [];



// WEBPACK FOOTER //
// ./src/routes/main/theme-reports-item-page/lazy.js